module.exports = __webpack_public_path__ + "img/emmanuel-trepant.d8d8b67d.jpg";